import React, { useContext, useMemo } from 'react';
import * as Styled from './styled';
import { ThemeContext } from '@src/index';

const DOT_COUNT = 24;

const random = (min, max) =>
    min + Math.random() * (max - min);

// Every card gets its own random scatter of micro dots:
// 1-3px bright specks, like tiny inclusions in the glass.
const generateDots = () =>
    Array.from({ length: DOT_COUNT }, (_, index) => {
        const size =
            1 +
            Math.round(Math.pow(Math.random(), 2.2) * 2);
        const duration = random(10, 22);

        return {
            id: index,
            size,
            left: random(2, 97),
            top: random(2, 97),
            opacity: random(0.3, 0.9),
            driftX: random(-2, 2),
            driftY: -random(1.5, 4),
            duration,
            delay: -random(0, duration),
        };
    });

const Card = ({
    children,
    className,
    onClick = () => {},
}) => {
    const palette = useContext(ThemeContext);
    const dots = useMemo(generateDots, []);

    return (
        <Styled.CardWrapper
            className={className}
            onClick={onClick}
            $CARD_BACKGROUND_COLOR={
                palette.CARD_BACKGROUND_COLOR
            }
            $CARD_BORDER_COLOR={palette.CARD_BORDER_COLOR}
            $isDarkMode={palette.isDarkMode}
        >
            <Styled.Dots aria-hidden="true">
                {dots.map(dot => (
                    <Styled.Dot
                        key={dot.id}
                        $dot={dot}
                        $isDarkMode={palette.isDarkMode}
                    />
                ))}
            </Styled.Dots>
            {children}
        </Styled.CardWrapper>
    );
};

export default Card;
